import React from 'react';
import {
  FDBodyText,
  FDBox, FDIcon, FDPaper, FDStack, FDTitleText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { dataAttrs } from 'Helpers/Testing';

const HorizontalPicklist = ({ options, value, onChange }) => {
  const theme = useTheme();
  return (
    <FDStack direction={'row'} spacing={2}>
      {
        options.map((option) => (
          <FDPaper appearance={'outlined'} color={value === option.id ? 'info' : undefined} alignSelf={'center'} width={'100%'} {...dataAttrs('horizontal-picklist-option')}>
            <Box
              sx={{
                borderRadius: '16px',
                '&:hover': {
                  cursor: 'pointer',
                  borderColor: 'inherit',
                  backgroundColor: theme.palette.facet.secondaryHover,
                },
              }}
              onClick={() => onChange(option.id)}
            >
              <FDStack direction={'column'} spacing={1} alignItems={'center'} padding={3}>
                <FDBox paddingY={1}>
                  <FDIcon icon={option.media} size={'lg'} />
                </FDBox>
                <FDTitleText color={'textSecondary'} size={'lg'} value={option.prompt} />
                <FDBodyText color={'textDisabled'} size={'sm'} value={option.description} align={'center'} />
              </FDStack>
            </Box>
          </FDPaper>

        ))
      }
    </FDStack>
  );
};

HorizontalPicklist.propTypes = {
  options: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

HorizontalPicklist.defaultProps = {
  options: {},
  value: undefined,
  onChange: noop,
};

export default HorizontalPicklist;
